import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {ChoiceList, Filters, Loading} from '@shopify/polaris'
import statuses from '../static/statuses'
import keys from '../static/keys'

const queryValueKeys = {
    'name': 'Name',
    'url': 'URL',
}

class FilterWebhook extends Component {
    state = {
        queryBy: 'name',
    }

    _onChangeQueryBy = ([by]) => {
        this.setState({
            queryBy: by,
        })
    }

    _onChange = key => ([v]) => this.props.setQuery({[key]: v})

    _onChangeText = key => v => this.props.setQuery({[key]: v}, true)

    _onQueryClear = key => () => this.props.setQuery({[key]: ''})

    _makeAppliedFilters = filter => {
        const result = []
        Object.keys(filter).forEach(key => {

            const label = (key === 'status') ? (statuses.find(i => i.value === filter[key]) || {}).label : filter[key]
            if (!label) return

            result.push({
                key,
                label: `${keys[key]}: ${label.toString()}`,
                onRemove: this._onQueryClear(key),
            })
        })

        return result
    }

    _clearFilter = () => {
        const {filter} = this.props
        const result = {}

        Object.keys(filter).forEach(key => result[key] = '')
        this.props.setQuery(result)
    }

    render() {
        const {query, loading} = this.props
        const {queryBy} = this.state
        const filters = [{
            key: 'queryBy',
            label: 'Search by',
            filter: (
                <ChoiceList
                    title="Search By"
                    choices={Object.keys(queryValueKeys).map(k => ({'value': k, 'label': queryValueKeys[k]}))}
                    selected={[queryBy]}
                    onChange={this._onChangeQueryBy}
                />
            ),
            shortcut: true,
        }, {
            key: 'status',
            label: 'Status',
            filter: (
                <ChoiceList
                    title="Status"
                    choices={statuses}
                    selected={query.status || []}
                    onChange={this._onChange('status')}
                />
            ),
        }]

        const appliedFilters = this._makeAppliedFilters(query)

        return (
            <React.Fragment>
                {loading && <Loading />}
                <Filters
                    disabled={loading}
                    queryValue={query[queryBy]}
                    filters={filters}
                    appliedFilters={appliedFilters}
                    queryPlaceholder={`Find by ${queryBy}`}
                    onQueryChange={this._onChangeText(queryBy)}
                    onQueryClear={this._onQueryClear(queryBy)}
                    onClearAll={this._clearFilter}
                />
            </React.Fragment>
        )
    }
}

FilterWebhook.propTypes = {
    query: PropTypes.object.isRequired,
    setQuery: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
}

export default FilterWebhook
